import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Logo from '../Images/Logo.png';

const FooterContainer = styled.footer`
    display: flex;
    width: 100%;
    height: 15vh;
    background-color: #10222E;
    justify-content: center;
    padding: 10px;
`
const InformationContainer = styled.section`
    display: flex;
    width: 95vw;
    height: 100%;
    justify-content: space-between;
`
const Image = styled.img`
  height: 100%;
  width: auto;
`;

const OptionsContainer = styled.section`
    width: 50vw;
    height: 100%;
    display: flex;
    color: #ffffff;
    justify-content: space-between;
    align-items: center;
    margin-right: 300px;
`

const Options = ['Privacy Policy', 'Cookies', 'Terms & Conditions', 'Copyright'];

const StyledLink = styled(Link)`
    color: #ffffff;
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    &:hover {
        text-decoration: underline;
        cursor: pointer;
    }
`;

function Footer(){
    return(
        <FooterContainer>
            <InformationContainer>
                <Link to="/">
                    <Image src={Logo} alt="Erro" />
                </Link>
                <OptionsContainer>
                    {Options.map((Option, index) => (
                        <StyledLink key={index} to={`/${Option.toLowerCase().replace(/\s/g, '')}`}>
                            {Option}
                        </StyledLink>
                    ))}
                </OptionsContainer>
            </InformationContainer>
        </FooterContainer>
    );
}

export default Footer;
